import { render } from "./3CarbonEmissions.vue?vue&type=template&id=381d4fab"
import script from "./3CarbonEmissions.vue?vue&type=script&lang=js"
export * from "./3CarbonEmissions.vue?vue&type=script&lang=js"
script.render = render

export default script